import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as Bearer (cookie also set serverside)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function spriteUrl(id) {
  return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`;
}

// Mapping of item_id → PokeAPI sprite key. Kept minimal — only for the item_ids
// that appear as event meta in the activity feed. Unknown ids fall through to a generic dot.
const ITEM_SPRITE_KEYS = {
  pokeball: "poke-ball", super_ball: "great-ball", hyper_ball: "ultra-ball", master_ball: "master-ball",
  pierre_feu: "fire-stone", pierre_eau: "water-stone", pierre_foudre: "thunder-stone",
  pierre_plante: "leaf-stone", pierre_lune: "moon-stone",
  charme_combat: "expert-belt",
  pepite: "nugget", perle: "pearl", grande_perle: "big-pearl",
  etoile_lune: "star-piece", tesson_pierre: "stardust", ecaille_coeur: "heart-scale",
  plume_sacree: "sacred-ash",
  poussiere_etoile: "stardust", eclat_cometoide: "comet-shard",
  os_rare: "rare-bone", grosse_pepite: "big-nugget", belle_plume: "pretty-wing",
  tesson_rouge: "red-shard", tesson_bleu: "blue-shard", tesson_vert: "green-shard", tesson_jaune: "yellow-shard",
  champi_petit: "tiny-mushroom", champi_gros: "big-mushroom", champi_baume: "balm-mushroom",
  chapelet_perles: "pearl-string", vestige_or: "relic-gold", couronne_antique: "relic-crown",
  boisson_fraiche: "fresh-water", soda_cool: "soda-pop", limonade: "lemonade",
  lait_meumeu: "moomoo-milk", vitesse_plus: "x-speed", attaque_plus: "x-attack",
};

export function itemSpriteUrl(itemId) {
  const key = ITEM_SPRITE_KEYS[itemId];
  if (!key) return null;
  return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/items/${key}.png`;
}
